export default {
  delete_operator_software: {
    'Irishluck.ie': true,
    'norskespilleautomater.com': true,
    'playcasino.co.za': true,
  },
  dynamic_prefilled_modules: {
    'default' : ['cards', 'cards_v2']
  },
  filter_cards_modules: {
    'irishluck.ie': ['inactive', 'blacklisted', 'coming_soon'],
    'norskespilleautomater.com': ['inactive', 'blacklisted', 'coming_soon'],
    'playcasino.co.za': ['inactive', 'blacklisted', 'coming_soon'],
    'onlinegamblingsa.co.za': ['inactive', 'blacklisted', 'coming_soon'],
    'onlinegamblingsa.com': ['inactive', 'blacklisted', 'coming_soon', 'not_recommended'],
    'onlinecasinosouthafrica.net': ['inactive', 'blacklisted', 'coming_soon', 'not_recommended'],
    'free-casinos.co.za': ['inactive', 'blacklisted', 'coming_soon', 'not_recommended'],
    'default': ['inactive', 'blacklisted']
  },
  keep_page_extra_fields: {
    operator: {
      'norskespilleautomater.com': true, // needed for inoperative / placeholder fields
      'irishluck.ie': true, // needed for card background image
      'playcasino.co.za': true,
    },
    article: {
      'irishluck.ie': true, // needed for card background image
      'norskespilleautomater.com': true,
      'playcasino.co.za': true,
    },
    game: {
      'irishluck.ie': true, // needed for card background image
      'norskespilleautomater.com': true,
      'playcasino.co.za': true,
      'casinomobile.co.za': true,
    },
  },
  keep_sections: {
    software_provider: { 'norskespilleautomater.com': ['header'], 'playcasino.co.za': ['header'] },
    payment_method: {
      'norskespilleautomater.com': ['header'],
      'playcasino.co.za': ['header'],
      'xn--nt-casino-v2a.se': ['header'],
    },
    operator: { 'Irishluck.ie': ['main'] },
    article: { 'Irishluck.ie': ['main'] },
  },
  app_ssr: [
    'homepage_sports',
    'event',
    'tournament',
    'lotto_results_and_fixtures',
    'personalized_toplist'
  ],
  newsletter:{
    default: {
      filter_pages: ['operator'],
    }
  },
  remove_bonus_data:{
    default:['withdrawal_methods', 'currencies', 'license_objects','deposit_methods' ],
    "casinossuisses.org": ['withdrawal_methods', 'currencies'],
    "demo-rocket-theme.gigmedia.com": ['withdrawal_methods', 'currencies']
  }
};
